import Model from '@/shared/orm/Model'
import router from '@/router'
import Permission from './Permission'
import i18n from '@/plugins/i18n'
export default class Role extends Model {
    resourceName() {
        return 'roles'
    }

    fields() {
        return ['id', 'name', 'home']
    }

    relationships() {
        return {
            permissions: new Permission(),
        }
    }

    computed() {
        return {
            homeShowName(role) {
                return router.resolve({ name: role.home }).resolved.meta
                    .showName
            },
            homeList() {
                let allowed = [
                    'dashboard',
                    'address.index',
                    'bank_account.index',
                    'bills',
                    'landingPage.index',
                    'category.index',
                    'commission.index',
                    'contact.index',
                    'customer',
                    'lead.index',
                    'role.index',
                    'user.index',
                ]

                return router.options.routes
                    .filter(route => {
                        return allowed.includes(route.name)
                    })
                    .sort((a, b) => {
                        if (a.path == '/') {
                            return -1
                        }

                        if (b.path == '/') {
                            return 1
                        }

                        return a.meta.showName > b.meta.showName ? 1 : -1
                    })
            },
        }
    }

    get tableColumns() {
        return [
            {
                text: i18n.t('roles.index.table.name'),
                value: 'name',
            },
            {
                text: i18n.t('roles.index.table.home'),
                value: 'homeShowName',
            },
            {
                text: i18n.t('tables.actions'),
                value: 'action',
                width: 150,
                sortable: false,
                align: 'end',
            },
        ]
    }
}
